import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Logo from '@results/components/ShopCard/Logo';
import Delivery from '@results/components/ShopCard/Delivery';

import Flex from '@components/Flex';

import Rating from '@components/Rating/WithBackground';

import { getShopLogo } from '@services/images.service';

const LogoContainer = styled.div`
  margin-bottom: 40px;
  max-width: 100px;
`;

const BodyContainer = styled.div`
  > div {
    margin-top: 5px;
    margin-bottom: 3px;
  }
`;

const DeliveryStyled = styled.div`
  margin-left: 12px;
`;

const RatingStyled = styled.div`
  display: flex;
`;

function ShopInfoShopCard({ shop }) {
  const imageURL = getShopLogo(shop.logo);

  return (
    <Flex row>
      <LogoContainer>
        <Logo
          isClosed={!shop.opened}
          imageSrc={imageURL}
          tagNew={shop.isNew}
          name={shop.name}
        />
      </LogoContainer>

      <BodyContainer>
        <RatingStyled>
          <Rating score={parseFloat(shop.generalScore).toFixed(1)} forCard />
        </RatingStyled>
        <DeliveryStyled>
          <Delivery
            minMinutes={shop.deliveryTimeMinMinutes}
            maxMinutes={shop.deliveryTimeMaxMinutes}
            deliveryTime={shop.deliveryTime}
            amount={shop.shippingAmount}
            isExpress={false}
          />
        </DeliveryStyled>
      </BodyContainer>
    </Flex>
  );
}

ShopInfoShopCard.propTypes = {
  shop: PropTypes.object.isRequired,
};

export default ShopInfoShopCard;
